import moment from "moment";

export enum TimeFrame {
  Today,
  LastWeek,
  LastMonth,
  LastYear,
}

export const TIME_FRAME_OPTIONS: { value: TimeFrame; label: string }[] = [
  { value: TimeFrame.Today, label: "Hoje" },
  { value: TimeFrame.LastWeek, label: "Última semana" },
  { value: TimeFrame.LastMonth, label: "Último mês" },
  { value: TimeFrame.LastYear, label: "Último ano" },
];

export function timeFrameToRange(value: TimeFrame): {
  startDate: string;
  endDate: string;
} {
  const endDate = moment().format("YYYY-MM-DD");
  let start = moment();

  switch (value) {
    case TimeFrame.Today:
      start = start.startOf("day");
      break;
    case TimeFrame.LastMonth:
      start = start.subtract(30, "days");
      break;
    case TimeFrame.LastYear:
      start = start.subtract(365, "days");
      break;
    case TimeFrame.LastWeek:
    default:
      start = start.subtract(6, "days");
      break;
  }

  return { startDate: start.format("YYYY-MM-DD"), endDate };
}
